import { render, staticRenderFns } from "./aOwnerDetailVisit.vue?vue&type=template&id=5f06b078&scoped=true"
import script from "./aOwnerDetailVisit.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailVisit.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailVisit.vue?vue&type=style&index=0&id=5f06b078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06b078",
  null
  
)

export default component.exports